<template>
  <v-container fluid class="pa-0">
    <v-card class="w-100 pa-4" elevation="2">
      <v-card-title>
        <v-row class="align-center justify-space-between">
          <v-col>
            <h3>Registered Applications</h3>
          </v-col>
          <v-col class="d-flex justify-end" cols="auto">
            <v-btn icon color="green" @click="addNewRow">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
  
      <div style="overflow-x: auto; width: 100%;">
        <v-data-table :items="apps" :headers="headers" class="elevation-1" dense fixed-header style="min-width: 900px;">
          <!-- Trading User ID -->
          <template v-slot:[`item.tradingUserId`]="{ item }">
            <v-text-field v-if="item.isNew || item.isEditing" v-model="item.tradingUserId" dense hide-details />
            <span v-else>{{ item.tradingUserId }}</span>
          </template>
  
          <!-- API Key -->
          <template v-slot:[`item.apiKey`]="{ item }">
            <v-text-field v-if="item.isNew || item.isEditing" v-model="item.apiKey" dense hide-details />
            <span v-else>{{ item.apiKey || '-' }}</span>
          </template>
  
          <!-- API Secret -->
          <template v-slot:[`item.apiSecret`]="{ item }">
            <v-text-field v-if="item.isNew || item.isEditing" v-model="item.apiSecret" dense hide-details />
            <span v-else>{{ item.apiSecret || '-' }}</span>
          </template>
  
          <!-- Application -->
          <template v-slot:[`item.application`]="{ item }">
            <v-select v-if="item.isNew || item.isEditing" v-model="item.application" :items="['BREEZE', 'KITE']" dense
              hide-details />
            <span v-else>{{ item.application }}</span>
          </template>
  
          <template v-slot:[`item.actions`]="{ item, index }">
            <!-- ✅ Save for new -->
            <v-icon v-if="item.isNew" color="green" class="me-2" style="cursor: pointer;"
              @click="addApplicationFromRow(item)">mdi-check</v-icon>
  
            <!-- ✅ Save for edit -->
            <v-icon v-else-if="item.isEditing" color="green" class="me-2" style="cursor: pointer;"
              @click="updateApplication(item)">mdi-check</v-icon>
  
            <!-- ✏️ Edit icon (only if not editing) -->
            <v-icon v-if="!item.isNew && !item.isEditing" class="me-2" style="cursor: pointer;"
              @click="editRow(item)">mdi-pencil</v-icon>
  
            <!-- ❌ Cancel edit icon -->
            <v-icon v-if="item.isEditing" color="red" size="18" class="cursor-pointer"
              @click="cancelEdit(item)">mdi-close</v-icon>
  
            <!-- 🗑️ Delete icon (only if not editing) -->
            <v-icon v-if="!item.isNew && !item.isEditing" color="red" style="cursor: pointer;"
              @click="removeRow(index)">mdi-delete</v-icon>
          </template>

        </v-data-table>
  
      </div>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { useDialog } from '@/composables/useDialog'
const { confirm } = useDialog()
export default {
  data() {
    return {
      apps: [],
      headers: [
        { title: 'Trading User ID', key: 'tradingUserId' },
        { title: 'API Key', key: 'apiKey' },
        { title: 'API Secret', key: 'apiSecret' },
        { title: 'Application', key: 'application' },
        { title: 'Actions', key: 'actions', sortable: false }
      ]
    };
  },
  mounted() {
    this.loadApplications();
  },
  methods: {
    ...mapActions('users', [
      'getTradingApplications',
      'addTradingApplication',
      'updateTradingApplication'
    ]),

    async loadApplications() {
      this.apps = await this.getTradingApplications();
    },

    addNewRow() {
      this.apps.push({
        tradingUserId: '',
        apiKey: '',
        apiSecret: '',
        application: '',
        isNew: true
      });
    },

    async addApplicationFromRow(row) {
      await this.addTradingApplication(row);
      this.loadApplications();
    },

    async updateApplication(row) {
      // ✅ Basic empty field validation
      if (
        !row.tradingUserId?.trim() ||
        !row.apiKey?.trim() ||
        !row.apiSecret?.trim() ||
        !row.application?.trim()
      ) {
        alert('All fields are required.');
        return;
      }

      try {
        await this.updateTradingApplication(row);
        row.isEditing = false;
        this.loadApplications();
      } catch (e) {
        console.error('❌ Failed to update application', e);
      }
    },

    editRow(row) {
      row.isEditing = true;
    },

    cancelEdit(row) {
      Object.assign(row, row._backup); // Restore original values
      row.isEditing = false;
      delete row._backup;
    },
    removeRow(index) {
      confirm({
        title: 'Delete Application',
        message: 'Are you sure you want to remove this row?',
        onConfirm: () => {
          this.apps.splice(index, 1)
        }
      })
    }
  }
};

</script>
